import React, { useEffect, useState } from "react";
import api from "../api/client";
import {
  Card, Button, Table, Modal, Form, Input, Space,
  message, Typography, Popconfirm, Tag
} from "antd";
import { PlusOutlined, ThunderboltOutlined } from "@ant-design/icons";
import EditableTable from "../components/EditableTable";

/* آدرسِ API از کلاینتِ مشترک (client.js) — قبلاً اینجا نمونهٔ محلیِ axios با
   پورتِ ۸۰۰۰ هاردکد بود و روی HTTPS (پورتِ بسته) «خطا در بارگذاری» می‌داد. */
const { Title } = Typography;

export default function DepartmentsPage() {
  const [depts, setDepts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form] = Form.useForm();

  const load = async () => {
    setLoading(true);
    try {
      const res = await api.get("/api/v1/departments/");
      setDepts(res.data);
    } catch { message.error("خطا"); }
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const handleSeed = async () => {
    try {
      const res = await api.post("/api/v1/departments/seed");
      message.success(res.data.message);
      load();
    } catch (e) { message.error(e?.response?.data?.detail || "خطا"); }
  };

  const openAdd = () => { form.resetFields(); setEditingId(null); setModalOpen(true); };
  const openEdit = (rec) => { form.setFieldsValue(rec); setEditingId(rec.id); setModalOpen(true); };

  const handleSave = async () => {
    const values = await form.validateFields();
    try {
      if (editingId) {
        await api.put(`/api/v1/departments/${editingId}`, values);
        message.success("ویرایش شد");
      } else {
        await api.post("/api/v1/departments/", values);
        message.success("بخش اضافه شد");
      }
      setModalOpen(false);
      load();
    } catch (e) { message.error(e?.response?.data?.detail || "خطا"); }
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/api/v1/departments/${id}`);
      message.success("حذف شد");
      load();
    } catch (e) { message.error(e?.response?.data?.detail || "خطا"); }
  };

  const handleInlineSave = async (id, changes) => {
    await api.put(`/api/v1/departments/${id}`, changes);
    load();
  };

  const columns = [
    { title: "نام بخش", dataIndex: "name", editType: "text",
      sorter: (a, b) => String(a.name || "").localeCompare(String(b.name || ""), "fa") },
    { title: "توضیحات", dataIndex: "description", editType: "text", render: v => v || "—" },
  ];

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 16 }}>
        <Title level={5} style={{ margin: 0 }}>بخش‌های سازمانی</Title>
        <Space>
          <Button icon={<ThunderboltOutlined />} onClick={handleSeed}>ثبت بخش‌های پیش‌فرض</Button>
          <Button type="primary" icon={<PlusOutlined />} onClick={openAdd}>بخش جدید</Button>
        </Space>
      </div>
      <Card>
        <EditableTable
          dataSource={depts}
          columns={columns}
          onSave={handleInlineSave}
          onDelete={handleDelete}
          loading={loading}
          pagination={false}
        />
      </Card>
      <Modal title={editingId ? "ویرایش بخش" : "بخش جدید"} open={modalOpen}
        onOk={handleSave} onCancel={() => setModalOpen(false)} okText="ذخیره" cancelText="انصراف">
        <Form form={form} layout="vertical" style={{ direction: "rtl" }}>
          <Form.Item name="name" label="نام بخش" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="description" label="توضیحات">
            <Input.TextArea rows={2} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
